import axios from 'axios';
import history from './history';
import { refreshTokenApi } from './apisConsts';
import { BASE_URL_SE } from '../../../shared/src/config/api';

const forceLogout = () => {
    // Backend will clear cookies automatically on logout
    // No need to remove cookies manually
    // Set auth state to false and redirect to login
    // Use getStore function to avoid circular dependency issues
    const getStore = () => {
        try {
            return require('../stores/index').default;
        } catch (e) {
            return null;
        }
    };
    
    const store = getStore();
    if (store) {
        const { isAuthintecated } = require('../stores/actions');
        store.dispatch(isAuthintecated(false));
    }
    history.push('/log-in');
};

export const refreshToken = async (): Promise<boolean> => {
    // Backend reads refreshToken from cookie automatically (HttpOnly)
    // Browser sends cookies automatically with withCredentials: true
    // No need to read refreshToken from cookies

    try {
        const currentTime = new Date().toLocaleTimeString('en-EG');
        // Browser sends refreshToken cookie automatically
        // Backend reads it from cookie and sets new cookies in response
        const { data } = await axios.post(
            `${BASE_URL_SE}${refreshTokenApi}`, 
            {}, // No need to send refreshToken in body - backend reads from cookie
            { withCredentials: true } // Important - enables automatic cookie transmission
        );

        // Check if refresh endpoint returns 401 Unauthorized
        if (data?.statusCode === 401 || data?.message === 'Unauthorized') {
            console.error(`[${currentTime}] Refresh token expired or invalid. Logging out...`);
            forceLogout();
            return false;
        }

        if (data && data?.status === 200) {
            console.log(`[${currentTime}] Token generated successfully`);

            // Backend sets new cookies automatically in response headers
            // Browser saves them automatically - no need to set cookies manually
            return true;
        } else {
            console.error(`[${currentTime}] Token refresh failed:`, data?.message || 'Unknown error');
            return false;
        }
    } catch (error: any) {
        const currentTime = new Date().toLocaleTimeString('en-EG');

        // Check if error response is 401 Unauthorized
        if (
            error?.response?.status === 401 ||
            error?.response?.data?.statusCode === 401 ||
            error?.response?.data?.message === 'Unauthorized'
        ) {
            console.error(`[${currentTime}] Refresh token expired or invalid. Logging out...`);
            forceLogout();
            return false;
        }

        console.error(`[${currentTime}] Error refreshing token:`, error);
        return false;
    }
};
